export default __webpack_public_path__ + "static/media/CBC.bb8ac987.svg";